// extracted by mini-css-extract-plugin
export default {"addItemCard":"CreateCardPlaceholder_addItemCard__XolFq"};